export const eventInfo = JSON.stringify({
  eventAction: "my account:account settings:edit profile",
  eventName: "my account:account settings:edit profile",
  eventType: "navigation",
  eventMsg: "n/a",
  eventStatus: "n/a",
  internalLinkName: "edit profile",
  internalLinkPosition: "my account",
  internalLinkType: "my account:navigation",
  internalLinkZoneName: "my account:account settings",
  internalLinkURL: "n/a",
  clickInternalLinks: "true",
})

export const addDataLayerEditProfileClose = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = {
    eventAction: "my account:account settings:modal:edit profile:close",
    eventName: "my account:account settings:modal:edit profile:close",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: "my account:account settings",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:account settings:modal:edit profile",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  window?.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
